module.exports = __webpack_public_path__ + "ba1673a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav_logo@2x.png
// module id = 897
// module chunks = 0 1 2 3 4 5